import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  modalTitle: {
    wordBreak: 'break-word',
    marginRight: theme.spacing(3),
  },
  modalText: {
    color: theme.palette.text.secondary,
    wordBreak: 'break-word',
  },
}));
